<template>
  <div class="d-content">
    <dashboard-content-nav :nav="navItems"/>
    <keep-alive>
            <component :is="currentComponent" :entity_index="entity_index"></component>
        </keep-alive>
  </div>
</template>
<script>
const nav_items = (entity_index) =>([ 
        {
          type: "navitem",
          label: "Payment Initiate",
          path:setPathFunction(entity_index,'paymentInitiate')
        },
        {
        type: "navitem",
         label: "Approved",
         path:setPathFunction(entity_index,'approvedHsbc')
        },
      ])
import accountPageHsbc from './accountPageHsbc.vue'
import paymentInitiate from './paymentInitiateHsbc.vue'
import approvedHsbc from './approvedHsbc.vue'
const mapNameToComponents = {
  "accountPageHsbc" :accountPageHsbc,
  "paymentInitiate" :paymentInitiate,
  "approvedHsbc" :approvedHsbc
}
const setPathFunction = (entity_index,step_name, sub_step) => 
{
      return `/dashboard/${entity_index}/hsbcAccounts/${step_name}`;
  }
import dashboardContentNav from "@/components/dashboard/contentNav.vue";
export default {
  components: {
    dashboardContentNav,
  },
  props: ['sub_step','entity_index'],
  data() {
    return {
        navItems:[],
    };
  },
  created(){
      this.navItems = nav_items(this.entity_index);
  },
  computed:{
    currentComponent: function() {
        return mapNameToComponents[this.sub_step];
    },
  },
  methods: {

  },
};
</script>
<style lang="scss" scoped>
.navText1 {
  white-space: nowrap;
  text-decoration: none;
  color: #646464;
  font-size: 12px;
  position: relative;
  display: block;
  font-weight: bold;
  border-bottom-width: 0 !important;
}
</style>
